import { Flex, MantineStyleProps } from "@mantine/core"
import styles from "./AEMSvg.module.css"

export interface AEMSvgData {
	path: string // This is meant to be an url
	title?: string | null
	description?: string
	iconColor?: string
	iconSvg?: string
}

interface AEMSvgProps extends MantineStyleProps {
	svgData: AEMSvgData
	ariaLabel?: string
	ariaRole?: React.AriaRole
	preserveColors?: boolean
	alt?: string
}

export const AEMSvg: React.FC<AEMSvgProps> = ({
	svgData,
	ariaLabel,
	ariaRole = "img",
	preserveColors = false,
	h,
	w,
	alt,
	...props
}) => {
	return (
		<Flex
			className={styles.icon}
			style={{
				"--icon-url": `url(${svgData?.path})`,
				"--svg-color": svgData?.iconColor
			}}
			h={h ?? "24px"}
			w={w ?? "24px"}
			role={ariaRole}
			aria-label={
				ariaLabel ?? alt ?? svgData?.description ?? svgData?.title ?? ""
			}
			data-icon-type={preserveColors ? "original" : undefined}
			{...props}
		>
			<img
				src={svgData?.path}
				role={ariaRole}
				alt={alt ?? svgData?.description ?? svgData?.title ?? ""}
				aria-label={ariaLabel ?? ""}
				aria-hidden="true"
				className={styles.iconImage}
			/>
		</Flex>
	)
}
